/* src/app/components/order-repeat/order-repeat.component.scss */
.close-button {
  color: black;
  min-height: 0;
  --border-radius: 0;
}
.close-button::part(native) {
  padding: 0;
}
.close-button ion-icon {
  font-size: 20px !important;
}
.header ion-icon {
  font-size: 40px;
}
.header .title {
  gap: 15px;
  color: #43c0f6;
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
@media (max-width: 628px) {
  .header ion-icon {
    font-size: 40px;
    min-width: 28px;
  }
  .header .title {
    font-size: 28px !important;
  }
}
title {
  display: inline;
}
hr {
  margin: 20px 0;
}
.body-title {
  color: #000;
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.body-text {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 20px;
}
/*# sourceMappingURL=order-repeat.component-CV75XO3E.css.map */
